module.exports = __webpack_public_path__ + "assets/img/gl.cddca0cf.png";